import React from "react";
import { Typography,Form, Input, Button,InputNumber } from "antd";

const { Text,Title } = Typography;

const Page403 = () => {
  
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>403</Title>
        </div>
        <div className="pch"></div>
      </div>
      <div className="p-content custom-config">
        <img src="403.jpg" />
      </div>
    </div>
  );
};
export default Page403;
